export default {
  addedProject(state) {
    return state.addedProject;
  },
};
